
import CreateExpenseVoucher from "../CreateForm/CreateExpenseVoucher";
import { useExportShipmentDetails } from './Hook/useExportShipmentDetails';
import React, { useState, useEffect, useRef, useCallback, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import { DELETE_EXPENSE_VOUCHER, GET_COMPANY_CURRENCY_LIST, LIST_COMMERCIAL_INVOICES_EXPORT, LIST_EXPENSE_VOUCHERS } from '../../../services/apiRoutes';
import { genericPost } from '../../../services/authServices';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { getCurrencyList, getExpenseLedgerList, getCommanExportShipmentId, getPartyLedger } from '../../../services/CommonServices';
import UpdateExpenseVoucher from '../UpdateForm/UpdateExpenseVoucher';
import ExpenseVoucherView from '../ViewDetails/ExpenseVoucherView';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import axios from 'axios';
import CustomStatus from "../../common/CustomStatus";

export default function ExpenseVoucher({ fetchButtonList }) {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();
    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = useState('Expense');
    const [partyLedger, setPartyLedger] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currencyList, setCurrencyList] = useState([]);
    const [expenseLedger, setExpenseLedger] = useState([]);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [companyCurrencyData, setCompanyCurrencyData] = useState([]);
    const [rowId, setRowId] = useState('')
    const [message, setMessage] = useState({
        open: false,
        text: '',
        type: ''
    });
    const [expenseVoucherId, setExpenseVoucherId] = useState('');
    const [viewModal, setViewModal] = useState(false);
    const navigate = useNavigate();
    const { exportShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useExportShipmentDetails(exportShipmentId);
    const [newShippingId, setNewShippingId] = useState(null);
    const [commercialInvoiceList, setCommercialInvoiceList] = useState([]);

    const customerId = useRef(null);
    const shipmentId = useRef(null);
    const cifFob = useRef(null);
    const shipmentOrgId = useRef(null);
    const currencyId = useRef(null);
    const baseCurrencyId = useRef(null);
    const currencySymbol = useRef(null);
    const baseCurrencySymbol = useRef(null);

    const hasFetched = useRef(false);

    const fetchDataCompanyCurrency = useCallback(async () => {
        setLoading(true);
        try {
            const payload = {
                id: [currencyId.current, baseCurrencyId.current],
            };
            const response = await genericPost(GET_COMPANY_CURRENCY_LIST, payload);
            if (response.data.success && response.data.currencyList) {
                const formattedCurrencyList = response.data.currencyList.map(currency => ({
                    id: currency.id,
                    name: currency.name,
                    title: `${currency.currency_symbol} ${currency.currency} - ${currency.name}`,
                    currencyName: currency.currency_name,
                    currencySymbol: currency.currency_symbol,
                }));
                setCompanyCurrencyData(formattedCurrencyList);
            } else {
                setError('No currency data found');
            }
        } catch (error) {
            setError('Error fetching currency data');
            console.error('Error fetching currency data', error);
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const payload = {
                clientCompanyId: customerId.current,
                shipmentId: shipmentId.current,
                commanShipmentId: getCommanExportShipmentId,

            };
            const response = await genericPost(LIST_EXPENSE_VOUCHERS, payload);
            if (response.data.success && response.data.expenseVoucher) {
                const expenseVoucherData = response.data.expenseVoucher.map((voucher, index) => ({
                    sn: voucher.expenseVoucherId || '',
                    index: (index + 1).toString().padStart(2, '0'),
                    dueDate: companyDateFormat(voucher?.dueDate) || '',
                    date: companyDateFormat(voucher?.date) || '',
                    voucherNo: voucher.voucherNo || '',
                    ledgerName: voucher.expenseLedger?.ledgerName || '',
                    currency: voucher.currency?.currency || '',
                    baseCurrency: voucher.baseCurrency?.currency || '',
                    amount1: `${voucher?.currency?.currency_symbol || ''} ${voucher.amount || ''}`,
                    conversionRate: `${voucher?.baseCurrency?.currency_symbol || ''} ${voucher.conversionRate || ''}`,
                    amount2: `${voucher?.baseCurrency?.currency_symbol || ''} ${voucher.amountInBaseCurrency || ''}`,
                    partyLedger: voucher.partyLedger?.partyName || '',
                    ledgerNameColor: voucher.expenseLedger?.ColorPlate?.color || "",
                    ledgerNameBgColor: voucher.expenseLedger?.ColorPlate?.backgroundColor || "",
                    partyLedgerColor: voucher?.partyLedger?.ColorPlate?.color || "",
                    partyLedgerBgColor: voucher?.partyLedger?.ColorPlate?.backgroundColor || "",
                }));
                const { newShippingId } = response.data;
                setNewShippingId(newShippingId);
                setData(expenseVoucherData);
            } else {
                setError('No expense vouchers found');
            }
        } catch (error) {
            setError('Error fetching expense vouchers');
            console.error('Error fetching expense vouchers', error);
        } finally {
            setLoading(false);
        }
    }, []);

    const getCommercialInvoice = async () => {
        try {
            if (!customerId.current || !shipmentId.current) {
                return;
            }
            const payload = {
                customerNamesId: customerId.current,
                shipmentId: shipmentId.current,
            };

            const response = await genericPost(LIST_COMMERCIAL_INVOICES_EXPORT, payload, {
            });
            if (response.data && response.data.success) {
                const invoices = response.data.data.map((invoice) => ({
                    id: invoice.commercialInvExpId,
                    title: invoice.commercialInvoiceNo,
                }));
                setCommercialInvoiceList(invoices);
            } else {
                console.error("No data available");
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };


    const handleDelete = async (ExpenseVoucherId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_EXPENSE_VOUCHER(ExpenseVoucherId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
                fetchButtonList();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };

    const getCommonData = useCallback(async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
        const expenseLedger = await getExpenseLedgerList();
        setExpenseLedger(expenseLedger);
        const partyLedger = await getPartyLedger();
        setPartyLedger(partyLedger);
    }, []);

    useEffect(() => {
        if (shipmentDetails && !hasFetched.current) {
            customerId.current = shipmentDetails.customerId;
            shipmentId.current = shipmentDetails.shipmentId;
            shipmentOrgId.current = shipmentDetails.exportShipmentId;
            cifFob.current = shipmentDetails.cifFob.cifFobName;
            currencyId.current = shipmentDetails.currencyId;
            baseCurrencyId.current = shipmentDetails?.company?.baseCurrencyData?.id ?? '';
            currencySymbol.current = shipmentDetails?.currency?.currency_symbol ?? '';
            baseCurrencySymbol.current = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
            fetchData();
            getCommonData();
            fetchDataCompanyCurrency();
            getCommercialInvoice();
            hasFetched.current = true;
        }
    }, [shipmentDetails, fetchData, token, deleteAlert, getCommonData]);


    const handleUpdateClick = (id) => {
        setExpenseVoucherId(id);
        setUpdateModal(true);
    };

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }


    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setExpenseVoucherId('');
    };

    const handleViewClick = (id) => {
        setExpenseVoucherId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setExpenseVoucherId('');
    };


    const expenseVoucherColumns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center',
            },
        },

        {
            id: 'voucherNo', label: 'Voucher No.', accessor: 'voucherNo', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'ledgerName',
            label: 'Expense Ledger',
            accessor: 'ledgerName',
            styleAccessor: {
                textAlign: 'center',
            },
            Cell: ({ row }) => {
                return (
                    <CustomStatus
                        title={row.ledgerName}
                        sx={{
                            backgroundColor: row.ledgerNameBgColor,
                            color: row.ledgerNameColor,
                            border: `1px solid ${row.ledgerNameColor}`,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },
        {
            id: 'partyLedger',
            label: 'Party Ledger',
            accessor: 'partyLedger',
            styleAccessor: {
                textAlign: 'center',
            },
            Cell: ({ row }) => {
                return (
                    <CustomStatus
                        title={row.partyLedger}
                        sx={{
                            backgroundColor: row.partyLedgerBgColor,
                            color: row.partyLedgerColor,
                            border: `1px solid ${row.partyLedgerColor}`,
                            textAlign: 'center',
                            display: 'inline-block',
                        }}
                    />
                );
            },
        },



        { id: 'currency', label: 'Currency', accessor: 'currency' },
        {
            id: 'amount1', label: 'Amount', accessor: 'amount1', styleAccessor: {
                textAlign: 'right',
            },
        },
        { id: 'baseCurrency', label: 'Base Currency', accessor: 'baseCurrency' },
        {
            id: 'conversionRate', label: 'conversion Rate', accessor: 'conversionRate', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'amount2', label: 'Amount in Base Currency', accessor: 'amount2', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'dueDate', label: 'due Date', accessor: 'dueDate', styleAccessor: {
                textAlign: 'center',
            },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.sn)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.sn)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.sn)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];

    return (
        <div>


            <CustomLoader open={loading} />
            <DetailsPageCard
                columns={expenseVoucherColumns}
                title={'Expense Voucher'}
                buttonTitle={'Create Expense'}
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={modal}  >
                <CreateExpenseVoucher
                    fetchData={fetchData}
                    commanShipmentId={getCommanExportShipmentId}
                    setMessage={setMessage}
                    handleClose={handleClose}
                    currencyList={currencyList}
                    companyCurrencyData={companyCurrencyData}
                    expenseLedger={expenseLedger}
                    fetchButtonList={fetchButtonList}
                    newShippingId={newShippingId}
                    shipmentId={shipmentId.current}
                    clientCompanyId={customerId.current}
                    currencyId={currencyId.current}
                    baseCurrencyId={baseCurrencyId.current}
                    currencySymbol={currencySymbol.current}
                    baseCurrencySymbol={baseCurrencySymbol.current}
                    shipmentOrgId={shipmentOrgId.current}
                    partyLedger={partyLedger}
                    commercialInvoiceList={commercialInvoiceList}

                />
            </CustomModal>
            <CustomModal open={updateModal}  >
                <UpdateExpenseVoucher
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    ExpenseVoucherId={expenseVoucherId}
                    currencyList={currencyList}
                    expenseLedger={expenseLedger}
                    companyCurrencyData={companyCurrencyData}
                    partyLedger={partyLedger}
                    commercialInvoiceList={commercialInvoiceList}

                />
            </CustomModal>

            <CustomModal
                modalStyles={{
                    maxHeight: '50vh',
                    top: "10%",
                }}
                open={viewModal} handleClose={handleCloseView}>
                <ExpenseVoucherView
                    fetchData={fetchData}
                    setMessage={setMessage}
                    handleClose={handleCloseView}
                    ExpenseVoucherId={expenseVoucherId}
                    currencyList={currencyList}
                    expenseLedger={expenseLedger}
                />
            </CustomModal>
            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
}
